import React from 'react';
import SentenceForm from "../../components/common/SentenceForm";
import Container from "@material-ui/core/Container";
import {useDispatch, useSelector} from "react-redux";
import TextField from "@material-ui/core/TextField";
import {makeStyles} from "@material-ui/core";
import ScrollableAnchor from "react-scrollable-anchor";
import {useRecoilState, useRecoilValue, useSetRecoilState} from "recoil";
import {answerState, menuCheckSelector, selectedMenuItemState, surveyDataState} from "../../state/globalState";

const useStyles = makeStyles(theme => ({
    root: {
        '&:hover': {
            backgroundColor: 'transparent',
        },
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end'
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(1),
    },
    icon: {
        borderRadius: '50%',
        width: 16,
        height: 16,
        boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
        backgroundColor: '#f5f8fa',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
        '$root.Mui-focusVisible &': {
            outline: '2px auto rgba(19,124,189,.6)',
            outlineOffset: 2,
        },
        'input:hover ~ &': {
            backgroundColor: '#ebf1f5',
        },
        'input:disabled ~ &': {
            boxShadow: 'none',
            background: 'rgba(206,217,224,.5)',
        },
    },
    checkedIcon: {
        backgroundColor: '#1b6817',
        backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
        '&:before': {
            display: 'block',
            width: 16,
            height: 16,
            backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
            content: '""',
        },
        'input:hover ~ &': {
            backgroundColor: '#1b6817',
        },
    },
    textField: {
        width: 300
    },
    formControl: {
        margin: theme.spacing(1),
        minWidth: 120
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

/**
 * 설문 문항 컴포넌트
 */
const Survey14 = (props) => {
    const surveyData = useRecoilValue(surveyDataState);
    const [answer, setAnswer] = useRecoilState(answerState);
    const setSelectedMenuItem = useSetRecoilState(selectedMenuItemState);
    const setMenuCheck = useSetRecoilState(menuCheckSelector);
    const classes = useStyles();
    const dispatch = useDispatch();
    const acntNo = answer.accNo;

    const handleInputAnswer = (e, column) => {
        const { value } = e.target;
        const onlyNums = value.replace(/[^0-9\-]/g, '');

        if (onlyNums.length < 31) {
            setAnswer({
                ...answer,
                [column]: onlyNums
            });

            setSelectedMenuItem('SURVEY_32');
            setMenuCheck(onlyNums !== '');
        }
    };

    return (
        <>
            <ScrollableAnchor id={"115"}>
                <div>
                <Container style={{background: 'transparent', marginBottom: '10px'}}>
                    <SentenceForm
                        title={surveyData[115].title}
                        sentences={surveyData[115].questions}
                        step={115}
                    />
                    <div className="textFieldContainer">
                        <TextField
                            key={'userName'}
                            className={classes.textField}
                            label="여기에 답변을 입력하십시오."
                            placeholder=""
                            margin="none"
                            value={acntNo}
                            onChange={(e) => handleInputAnswer(e, 'accNo')}
                        />
                    </div>
                </Container>
                </div>
            </ScrollableAnchor>
        </>
    );
};

export default Survey14;
